var map = {
	"./Frage1_2048x1536.jpg": "3116",
	"./Frage2_2048x1536.jpg": "a988",
	"./Frage3_2048x1536.jpg": "033e",
	"./Frage4_2048x1536.jpg": "dc49",
	"./Frage5_2048x1536.jpg": "d8d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35a5";